module.exports = __webpack_public_path__ + "static/img/Finch_h5.8d468ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Finch_h5.png
// module id = bh3b
// module chunks = 34